export default function Logo({ className = "h-10 w-10" }) {
  return (
    <span
      className={`inline-flex items-center justify-center overflow-hidden rounded-full bg-ivory ring-1 ring-gold/40 ${className}`}
      aria-hidden="true"
    >
      <img src="/images/brand-mark.png" alt="" className="h-[80%] w-[80%] object-contain" />
    </span>
  );
}
